/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { ShipmentGroupSolutionSegmentDtoModel } from '@well/delivery-libs/shipment/domain';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { AbstractResourceService, JsonApiResource } from '@irian-ro/abstract-resource';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShipmentGroupSolutionSegmentResourceService extends AbstractResourceService<any, ShipmentGroupSolutionSegmentDtoModel, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('shipmentGroupSolutionSegmentUrl'),
      undefined,
      ShipmentGroupSolutionSegmentDtoModel
    );
  }

  getShipmentGroupSolutionSegment(solutionSegmentUuid: string)
    : Observable<JsonApiResource<ShipmentGroupSolutionSegmentDtoModel, any>> {
    return <Observable<JsonApiResource<ShipmentGroupSolutionSegmentDtoModel, any>>>this.httpClient?.get(`${this.url}/${solutionSegmentUuid}`);
  }

  updateShipmentGroupSolutionSegment(segment: ShipmentGroupSolutionSegmentDtoModel)
    : Observable<JsonApiResource<ShipmentGroupSolutionSegmentDtoModel, any>> {
    return <Observable<JsonApiResource<ShipmentGroupSolutionSegmentDtoModel, any>>>this.httpClient?.put(`${this.url}`, segment);
  }
}
